import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilState, useRecoilValue } from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
  editModeState,
  editObjState,
} from "../recoil-atom"

const Finance = () => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const [range, setRange] = useState({
    day1: "block",
    day90: "none",
    day365: "none",
    day1095: "none",
  })

  const now = new Date("2022-12-01")
  const sid = now.getTime()

  const korea = [
    { title: "코스피", code: "KOSPI" },
    { title: "코스닥", code: "KOSDAQ" },
  ]
  const world = [
    { title: "다우산업", code: "DJI@DJI" },
    { title: "나스닥종합", code: "NAS@IXIC" },
    { title: "S&P 500", code: "SPI@SPX" },
    { title: "상해종합", code: "SHS@000001" },
    { title: "항셍", code: "HSI@HSI" },
    { title: "유로스톡스 50", code: "STX@SX5E" },
    { title: "인도 SENSEX", code: "INI@BSE30" },
  ]
  const marketindex = [
    {
      title: "WTI(서부텍사스유, 달러/배럴)",
      code: "OIL_CL",
      link: "https://finance.naver.com/marketindex/worldOilDetail.naver?marketindexCd=OIL_CL&fdtc=2",
    },
    {
      title: "달런인덱스",
      code: "FX_USDX",
      link: "https://finance.naver.com/marketindex/worldExchangeDetail.naver?marketindexCd=FX_USDX",
    },
    {
      title: "KRW/USD",
      code: "FX_USDKRW",
      link: "https://finance.naver.com/marketindex/exchangeDetail.naver?marketindexCd=FX_USDKRW",
    },
    // {
    //   title: "국제 금",
    //   code: "CMDT_GC",
    //   link: "https://finance.naver.com/marketindex/worldGoldDetail.naver?marketindexCd=CMDT_GC&fdtc=2",
    // },
    {
      title: "CD금리(91일)",
      code: "IRR_CD91",
      link: "https://finance.naver.com/marketindex/interestDetail.naver?marketindexCd=IRR_CD91",
    },
    // {
    //   title: "구리(달러/톤)",
    //   code: "MCDT_CDY",
    //   link: "https://finance.naver.com/marketindex/interestDetail.naver?marketindexCd=IRR_CD91",
    // },
    // {
    //   title: "옥수수(센트/부셀)",
    //   code: "CMDT_C",
    //   link: "https://finance.naver.com/marketindex/materialDetail.naver?marketindexCd=CMDT_C",
    // },
    // {
    //   title: "오렌지주스(센트/파운드)",
    //   code: "CMDT_OJ",
    //   link: "https://finance.naver.com/marketindex/materialDetail.naver?marketindexCd=CMDT_OJ",
    // },
  ]

  const stock = [
    // 관심종목
    { title: "삼성전자", code: "005930", where: "interesting" },
    { title: "네이버", code: "035420", where: "interesting" },
    { title: "인탑스", code: "049070", where: "interesting" },
    { title: "쏘카", code: "403550", where: "interesting" },
    // KB증권
    { title: "코웰패션", code: "033290", where: "kb" },
    { title: "KODEX 유럽탄소배출권선물ICE(H)", code: "400570", where: "kb" },
    // NH증권
    { title: "SK하이닉스", code: "000660", where: "nh" },
    // { title: "SK텔레콤", code: "017670", where: "nh" },
    { title: "KT&G", code: "033780", where: "nh" },
    { title: "LG전자", code: "066570", where: "nh" },
    // { title: "우리금융지주", code: "316140", where: "nh" },
    // { title: "케이카", code: "381970", where: "nh" },
    // 삼성증권
    { title: "기아", code: "000270", where: "ss" },
    { title: "삼성전기", code: "009150", where: "ss" },
    { title: "LG유플러스", code: "032640", where: "ss" },
    // { title: "SK", code: "034730", where: "ss" },
    // { title: "신한지주", code: "055550", where: "ss" },
    { title: "TIGER KRX바이오K-뉴딜", code: "364970", where: "ss" },
    { title: "TIGER KRX2차전지K-뉴딜", code: "364980", where: "ss" },
    { title: "TIGER KRX인터넷K-뉴딜", code: "365000", where: "ss" },
    // 신한투자
    // { title: "TIGER 유로스탁스50(합성H)", code: "195930", where: "sh" },
    // { title: "ARIRANG 신흥국MSCI(합성H)", code: "195980", where: "sh" },
    { title: "TIGER 미국다우존스30", code: "245340", where: "sh" },
    { title: "KODEX 선진국 MSCI World", code: "251350", where: "sh" },
    { title: "KODEX 종합채권(AA-이상)액티브", code: "273130", where: "sh" },
    { title: "KODEX 200미국채혼합", code: "284430", where: "sh" },
    // { title: "KODEX 미국FANG플러스(H)", code: "314250", where: "sh" },
    { title: "KODEX 혁신기술테마액티브", code: "364690", where: "sh" },
    { title: "TIGER AI코리아프로스액티브", code: "365040", where: "sh" },
  ]

  return (
    <>
      <div className="flex-center">
        <div className="range-buttons">
          <button
            onClick={() => {
              setRange({
                day1: "block",
                day90: "none",
                day365: "none",
                day1095: "none",
              })
            }}
          >
            1
          </button>
          <button
            onClick={() => {
              setRange({
                day1: "none",
                day90: "block",
                day365: "none",
                day1095: "none",
              })
            }}
          >
            90
          </button>
          <button
            onClick={() => {
              setRange({
                day1: "none",
                day90: "none",
                day365: "block",
                day1095: "none",
              })
            }}
          >
            365
          </button>
          <button
            onClick={() => {
              setRange({
                day1: "none",
                day90: "none",
                day365: "none",
                day1095: "block",
              })
            }}
          >
            1095
          </button>
        </div>
      </div>
      <div className="charts">
        {korea.map((stock, index) => (
          <div key={stock.code} id={stock.code}>
            <a
              href={`https://finance.naver.com/sise/sise_index.naver?code=${stock.code}`}
              target="_blank"
            >
              <div
                style={{ backgroundColor: `${theme.b2}`, color: `${theme.f0}` }}
              >
                &nbsp;&nbsp;{stock.title}
                &nbsp;&nbsp;[<span style={{color: "#9E5CCD"}}>개인</span>
                &nbsp;&nbsp;<span style={{color: "#F48416"}}>외국인</span>
                &nbsp;&nbsp;<span style={{color: "#1193F0"}}>기관</span>]
              </div>
              <img
                src={`https://ssl.pstatic.net/imgfinance/chart/sise/siseMain${stock.code}.png?sid=${sid}`}
                width={size.pageWidth}
                style={{
                  border: `solid 1px ${theme.b2}`,
                }}
              />
              <img
                src={`https://ssl.pstatic.net/imgstock/chart3/day1095/${stock.code}.png?sid=${sid}`}
                width={size.pageWidth / 4}
              />
              <img
                src={`https://ssl.pstatic.net/imgstock/chart3/day365/${stock.code}.png?sid=${sid}`}
                width={size.pageWidth / 4}
              />
              <img
                src={`https://ssl.pstatic.net/imgstock/chart3/day90/${stock.code}.png?sid=${sid}`}
                width={size.pageWidth / 4}
              />
              <img
                src={`https://ssl.pstatic.net/imgstock/chart3/day/${stock.code}.png?sid=${sid}`}
                width={size.pageWidth / 4}
              />
            </a>
          </div>
        ))}

        {world.map((stock, index) => (
          <div key={stock.code}>
            <a
              href={`https://finance.naver.com/world/sise.naver?symbol=${stock.code}`}
              target="_blank"
            >
              <div
                style={{ backgroundColor: `${theme.b2}`, color: `${theme.f0}` }}
              >
                &nbsp;&nbsp;{stock.title}
              </div>
              <img
                src={`https://ssl.pstatic.net/imgfinance/chart/world/continent/${stock.code}.png?${sid}`}
                width={size.pageWidth}
                style={{
                  display: `${range.day1}`,
                  border: `solid 1px ${theme.b2}`,
                }}
              />
              <img
                src={`https://ssl.pstatic.net/imgfinance/chart/world/candle/day/${stock.code}.png?${sid}`}
                width={size.pageWidth}
                style={{
                  display: `${range.day90}`,
                  border: `solid 1px ${theme.b2}`,
                }}
              />
              <img
                src={`https://ssl.pstatic.net/imgfinance/chart/world/candle/week/${stock.code}.png?${sid}`}
                width={size.pageWidth}
                style={{
                  display: `${range.day365}`,
                  border: `solid 1px ${theme.b2}`,
                }}
              />
              <img
                src={`https://ssl.pstatic.net/imgfinance/chart/world/candle/month/${stock.code}.png?${sid}`}
                width={size.pageWidth}
                style={{
                  display: `${range.day1095}`,
                  border: `solid 1px ${theme.b2}`,
                }}
              />
            </a>
          </div>
        ))}

        {marketindex.map((stock, index) => (
          <div key={stock.code}>
            <a
              href={`https://finance.naver.com/marketindex/exchangeDetail.naver?marketindexCd=${stock.code}`}
              target="_blank"
            >
              <div
                style={{ backgroundColor: `${theme.b2}`, color: `${theme.f0}` }}
              >
                &nbsp;&nbsp;{stock.title}
              </div>
              <img
                src={`https://ssl.pstatic.net/imgfinance/chart/marketindex/area/month/${stock.code}.png?sidcode=`}
                width={size.pageWidth}
                style={{
                  display: `${range.day1}`,
                  border: `solid 1px ${theme.b2}`,
                }}
              />
              <img
                src={`https://ssl.pstatic.net/imgfinance/chart/marketindex/area/month3/${stock.code}.png?sidcode=`}
                width={size.pageWidth}
                style={{
                  display: `${range.day90}`,
                  border: `solid 1px ${theme.b2}`,
                }}
              />
              <img
                src={`https://ssl.pstatic.net/imgfinance/chart/marketindex/area/year/${stock.code}.png?sidcode=`}
                width={size.pageWidth}
                style={{
                  display: `${range.day365}`,
                  border: `solid 1px ${theme.b2}`,
                }}
              />
              <img
                src={`https://ssl.pstatic.net/imgfinance/chart/marketindex/area/year5/${stock.code}.png?sidcode=`}
                width={size.pageWidth}
                style={{
                  display: `${range.day1095}`,
                  border: `solid 1px ${theme.b2}`,
                }}
              />
            </a>
          </div>
        ))}

        {stock.map((stock, index) => {
          let shadowColor = "gray"
          if (stock.where === "nh") shadowColor = "#583E26"
          if (stock.where === "ss") shadowColor = "#02315E"
          if (stock.where === "sh") shadowColor = "#1A2902"

          return (
            <div key={stock.code} id={stock.code}>
              <a
                href={`https://finance.naver.com/item/main.naver?code=${stock.code}`}
                target="_blank"
              >
                <div
                  style={{ backgroundColor: `${shadowColor}`, color: "white" }}
                >
                  &nbsp;&nbsp;{stock.title}
                </div>
                <img
                  src={`https://ssl.pstatic.net/imgfinance/chart/item/area/week/${stock.code}.png?sidcode=${sid}`}
                  width={size.pageWidth}
                  style={{
                    display: `${range.day1}`,
                    border: `solid 1px ${shadowColor}`,
                  }}
                />
                <img
                  src={`https://ssl.pstatic.net/imgfinance/chart/item/candle/day/${stock.code}.png?sidcode=${sid}`}
                  width={size.pageWidth}
                  style={{
                    display: `${range.day90}`,
                    border: `solid 1px ${shadowColor}`,
                  }}
                />
                <img
                  src={`https://ssl.pstatic.net/imgfinance/chart/item/candle/week/${stock.code}.png?sidcode=${sid}`}
                  width={size.pageWidth}
                  style={{
                    display: `${range.day365}`,
                    border: `solid 1px ${shadowColor}`,
                  }}
                />
                <img
                  src={`https://ssl.pstatic.net/imgfinance/chart/item/candle/month/${stock.code}.png?sidcode=${sid}`}
                  width={size.pageWidth}
                  style={{
                    display: `${range.day1095}`,
                    border: `solid 1px ${shadowColor}`,
                  }}
                />
              </a>
            </div>
          )
        })}
      </div>

      <style jsx>{`
        .flex-center {
          position: absolute;
          z-index: 10;
          bottom: 0;
          left: 0;
          width: 100vw;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .range-buttons {
          width: ${size.appWidth}px;
          margin: 10px auto 20px auto;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr 1fr;
        }
        .charts {
          width: ${size.appWidth}px;
          margin: 10px auto 20px auto;
          border-radius: 20px;
          ${size.appPage === 2 ? "padding: 20px;" : "padding: 20px 0;"}
          background-color: ${userObj ? userObj.colors.b1 : theme.b1};
          display: grid;
          grid-template-columns: repeat(${size.appPage}, 1fr);
          ${size.appPage === 2 ? "gap: 20px;" : "gap: 5px;"}
          box-shadow: 1px 1px 3px 1px ${userObj ? userObj.colors.b2 : theme.b2};
        }
      `}</style>
    </>
  )
}

export default Finance
